export default __webpack_public_path__ + "static/media/thumbnail-6.3fbf1479.jpg";